export const ATG_PRODUCT_FEATURE_SPECS_FEATURE = 'atgProductFeatureSpecs';
